import type { HostInventory } from '@terra/shared-dto-chat-types';

let cachedHostInventory: HostInventory | undefined;
let pendingHostInventory: Promise<HostInventory | undefined> | null = null;

export function primeHostInventory(): Promise<HostInventory | undefined> {
  const api = window.electronAPI?.host;

  if (!api) {
    return Promise.resolve(undefined);
  }

  if (pendingHostInventory) {
    return pendingHostInventory;
  }

  pendingHostInventory = api
    .getInventory()
    .then((inventory) => {
      cachedHostInventory = inventory;

      return inventory;
    })
    .catch((error: unknown) => {
      console.warn('[host-inventory] Failed to read host inventory', error);

      return undefined;
    })
    .finally(() => {
      pendingHostInventory = null;
    });

  return pendingHostInventory;
}

export function getCachedHostInventory(): HostInventory | undefined {
  if (!cachedHostInventory && !pendingHostInventory) {
    void primeHostInventory();
  }

  return cachedHostInventory;
}
